import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const DrawingEditorRedoV2Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon drawing-editor-redo-v-2"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M15.834 5h-6.25a6.25 6.25 0 1 0 0 12.5h3.125m1.458-15 2.5 2.5-2.5 2.5"
        />
    </svg>
);
const Memo = memo(DrawingEditorRedoV2Icon);
export default Memo;
